import environment from "@analytics-environment";
import StringDictionary from "../types/string-dictionary";

export type AnalyticsMetaData = {
    cta_text?: string,
    component_name?: string,
    component_type?: string,
    nav_item?: string,
    nav_location?: string,
    nav_text?: string,
    section_name?: string,
    target_page_url?: string
}

export const getAnalyticTags = (meta: AnalyticsMetaData) => {
    if (!environment.analytics.enabled) {
        return {};
    }

    const properties = Object.keys(meta);

    const dict: StringDictionary = {};

    properties.forEach(key => {
        const metaKey = key as keyof typeof meta;

        if (!meta[metaKey]) {
            return;
        }

        dict[key] = meta[metaKey] ?? "";
    });

    const defaults = environment.analytics.defaults;

    if (!!defaults.component_name) {
      dict.component_name = defaults.component_name;
    }
    if (!!defaults.journey_name) {
      dict.journey_name = defaults.journey_name;
    }
    dict.current_page_url = window.location.href;
    dict.target_page_url = window.location.href;

    const info = JSON.stringify(dict);

    return {
        "data-component-name": dict.component_name,
        "data-component-info": info
    };
}

export const getButtonAnalytics = (navLocation: string, buttonText: string) => {
    const meta = {
        cta_text: buttonText,
        component_type: "button",
        nav_location: navLocation
    }

    return getAnalyticTags(meta);
}

export default getAnalyticTags;
